module.exports = __webpack_public_path__ + "img/document.0775ac0d.svg";